import { rgba } from 'polished';
import PropTypes from 'prop-types';
import { ButtonOutline } from 'remote-com-shared/components/Button';
import { fluidProp, whenProp } from 'remote-com-shared/style/helpers';
import { breakpointFrom } from 'remote-com-shared/style/mediaQueries';
import { sharedTransition } from 'remote-com-shared/style/motion';
import styled, { css } from 'styled-components';

import { fromBreakpointReference, sharedShadowDown } from './shared';

export const Wrapper = styled.header`
  ${sharedTransition('color, background-color, box-shadow')}

  --panelXSpace: 16px;
  --panelYSpace: 16px;
  --entryYSpace: 14px;
  --entryXSpace: var(--panelXSpace);

  --enterDuration: 0.2s;
  --leaveDuration: 0.1s;
  --enterTiming: ease-out;
  --leaveTiming: ease-in;
  --arrowDecoratorWidth: 18px;
  --arrowDecoratorMargin: 2px;

  --toggleLineColor: currentColor;
  --menuInteractionHighlightColor: var(--colors-blank);
  --menuInteractionHighlightBorderColor: var(--colors-turquoise);

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10; // Observed going below the hero
  display: flex;
  flex-direction: column;
  font-size: 16px;
  line-height: 1.18em;
  font-weight: 500;
  color: var(--colors-blank);

  ${breakpointFrom.sm(css`
    --panelXSpace: 26px;
    --panelYSpace: 20px;
    --entryYSpace: 16px;
  `)}

  ${fromBreakpointReference(css`
    --entryYSpace: 26px;
    --entryXSpace: 0;

    flex-direction: row;
    align-items: center;
    color: ${({ theme }) => rgba(theme.colors.blank, 0.7)};
    ${fluidProp(['padding-left', 'padding-right'], '0px', '52px')}
    ${fluidProp(['padding-top', 'padding-bottom'], '0px', '22px')}

    ${whenProp(
      '$isFixed',
      css`
        --menuInteractionHighlightColor: currentColor;
        color: var(--colors-darkBlue);
        ${fluidProp(['padding-top', 'padding-bottom'], '0px', '8px')}
      `
    )}
  `)}

  ${whenProp(
    ['$isFixed', '$isOpen'],
    css`
      position: fixed;
      color: var(--colors-darkBlue);
      background-color: var(--colors-blank);
      box-shadow: ${sharedShadowDown};
    `
  )}

  a {
    color: inherit;
  }

  // Customize ButtonOutline
  ${whenProp(
    ['$isFixed', '$isOpen'],
    css`
      ${ButtonOutline} {
        --textColor: var(--colors-irisBlue);
        --borderColor: var(--colors-irisBlue);
      }
    `
  )}
`;

Wrapper.propTypes = {
  /** Both of these states share some similar styles such as background and color */
  /** Used to style when not intersecting hero */
  $isFixed: PropTypes.bool,
  /** Used to style when mobile version is open */
  $isOpen: PropTypes.bool,
};

export default Wrapper;
